/**
 * Session cache for Team Management header tab counts.
 * Tables use teamManagementViewCache for rows; this keeps (All users)(Agents)… instant on revisit.
 * Cleared on logout with team view cache.
 */

const defaultCounts = () => ({
  allUsers: 0,
  agents: 0,
  supervisors: 0,
  suspendedAgents: 0,
  groups: 0,
  suspendedGroups: 0,
});

let cache = {
  businessId: null,
  hasFetched: false,
  counts: null,
};

export function getTeamManagementCountsWarmCache() {
  return cache;
}

/** Replace whole cache entry (e.g. after a full counts fetch). */
export function setTeamManagementCountsWarmCache(next) {
  const counts =
    next.counts != null
      ? { ...defaultCounts(), ...next.counts }
      : null;
  cache = {
    businessId: next.businessId ?? null,
    hasFetched: Boolean(next.hasFetched),
    counts,
  };
}

/** Merge partial counts for the same business (preserves fields not passed). */
export function patchTeamManagementCountsWarmCache(businessId, partial) {
  if (!businessId || !partial || typeof partial !== "object") return;
  const sameBiz = String(cache.businessId) === String(businessId);
  const base = sameBiz && cache.counts ? cache.counts : defaultCounts();
  cache = {
    businessId,
    hasFetched: true,
    counts: { ...defaultCounts(), ...base, ...partial },
  };
}

export function clearTeamManagementCountsWarmCache() {
  cache = { businessId: null, hasFetched: false, counts: null };
}
